import React, { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import PropTypes from 'prop-types';

export default function PageContainer({
  children,
  actions,
  setFormikActions,
  title,
}) {
  useEffect(() => {
    setFormikActions(actions);
  }, []);

  return (
    <View style={styles.container}>
      {title ? <Text style={styles.title}>{title}</Text> : null}
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 15,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
  },
});

PageContainer.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};
